module.exports = __webpack_public_path__ + "img/rtf.2e6a179e.svg";